import { Link } from "react-router-dom";
import CharityIcon from "../../../../ui/components/icons/charity-icon";
import GoogleRatingIcon from "../../../../ui/components/icons/google-rating-icon";
import { Button } from "../../../../ui/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../../../ui/components/ui/dialog";

const GoogleRatingModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="p-12 min-w-[600px]">
        <DialogHeader className="flex flex-col items-center justify-center gap-4">
          <div className="h-12">
            <GoogleRatingIcon />
          </div>
          <DialogTitle className="text-center text-2xl font-bold">50€ für deine Bewertung</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-4 mt-4">
          <p className="text-center font-semibold text-[#888888]">
            Hilf anderen Unternehmen bei ihrer Entscheidung und teile Deine Erfahrung mit der 7i7® Design Flatrate!
            Bewerte uns auf Google und unterstütze damit andere, den richtigen Partner zu finden. Als Dankeschön für
            Dein wertvolles Feedback erhältst Du eine Gutschrift in Höhe von 50 € auf Deine nächste Rechnung.
          </p>
          <p className="text-center text-sm font-semibold text-[#888888]">
            Sende uns dafür einfach einen Screenshot oder den Link zu Deiner Bewertung an buchhaltung@7i7.de.
          </p>
          <Link to="https://g.page/r/Cdcr2wCMjvtqEAE/review" target="_blank">
            <Button className="w-full flex items-center justify-center gap-4">
              <CharityIcon />
              Jetzt auf Google bewerten & 50€ erhalten
            </Button>
          </Link>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default GoogleRatingModal;
